export default "__VITE_ASSET__1f5ca991__"